import React from 'react';
import LocalizedStrings from 'react-localization';
import en from '../locales/en';

const localizationObject = new LocalizedStrings({ en });
const LocalizationContext = React.createContext(localizationObject);

export type LocaleObject = typeof localizationObject;
export default LocalizationContext;
